import React, { useState } from "react";
import bg from "../../assets/first_bg.png";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config/apiConfig";
import { toast } from "sonner";

const FreeLoginPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const savedToken = localStorage.getItem("token");

            const response = await fetch(`${API_BASE_URL}/api/free-users/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(savedToken ? { Authorization: `Bearer ${savedToken}` } : {})
                },
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("token", data.token);
                localStorage.setItem("accountType", "free");
                localStorage.setItem("isFreeUser", true);
                localStorage.setItem("sessionStart", new Date().toISOString());

                toast.success("Free session started!");

                if (!data.user.subjects || data.user.subjects.length === 0) {
                    navigate("/free-onboarding");
                } else {
                    navigate("/free-dashboard");
                }
            } else {
                setError(data.message || "Login failed.");
                toast.error(data.message || "Login failed.");
            }
        } catch (err) {
            console.error("Login error:", err);
            toast.error("An error occurred. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            className="flex justify-center items-center min-h-screen"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#2148C0",
            }}
        >
            <div className="flex flex-col md:flex-row bg-transparent rounded-lg overflow-hidden w-full max-w-4xl">
                <div className="w-[80%] m-auto md:w-1/2 p-8 flex flex-col justify-center bg-opacity-80 rounded-lg">
                    <h2 className="text-3xl font-bold text-center mb-2 text-white">TeeChaa</h2>
                    <p className="text-center text-sm text-gray-300 mb-4">
                        You are logging in as a <span className="font-semibold">Free User</span>.
                        Some features may be limited.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-5">

                        {/* Error */}
                        {error && (
                            <p className="text-sm text-red-500 bg-white px-2 py-1 rounded">
                                {error}
                            </p>
                        )}

                        {/* Button */}
                        <button
                            type="submit"
                            className="w-full bg-white text-[#2148C0] p-2 rounded-lg hover:bg-gray-200 transition duration-300"
                        >
                            {isLoading ? (
                                <svg
                                    className="animate-spin h-5 w-5 text-[#2148C0] m-auto"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    ></path>
                                </svg>
                            ) : (
                                "Start Your Free Test"
                            )}
                        </button>
                    </form>

                    <p className="mt-4 text-center text-gray-300">
                        Don't have an account?{" "}
                        <a href="/signup" className="text-white hover:underline">
                            Sign Up
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FreeLoginPage;
